import React from 'react';
import { ConflictDetector } from '../components/ConflictDetector';

export function ConflictsPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 py-6">
      <ConflictDetector />
    </div>
  );
}
